import { render, staticRenderFns } from "./BaseCopyRight.vue?vue&type=template&id=19500a8e&"
import script from "./BaseCopyRight.vue?vue&type=script&lang=js&"
export * from "./BaseCopyRight.vue?vue&type=script&lang=js&"
import style0 from "./BaseCopyRight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports